import { styled } from "@mui/material/styles";
import { Tab, Tabs } from "@mui/material";

export const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => !["active"].includes(prop),
})(({ active, theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  textTransform: "none",
  color: theme.palette.hubColors.grey,
  padding: "8px 14px",
  minHeight: 32,
  minWidth: 0,
  borderRadius: "6px 6px 0 0",
  transition: "color 0.2s ease, background-color 0.2s ease",
  "&:hover": {
    color: theme.palette.hubColors.greyDark2,
    backgroundColor: theme.palette.hubColors.greyLightTransparent,
  },
  ...(active && {
    color: theme.palette.hubColors.mainFocus,
    fontWeight: 600,
  }),
}));

export const StyleTabContainer = styled(Tabs)(({ theme }) => ({
  overflow: "visible",
  minHeight: 32,
  marginBottom: -1,
  "& .MuiTabs-scroller": {
    overflow: "visible !important",
  },
  "& .MuiTabs-indicator": {
    height: 2,
    borderRadius: "2px 2px 0 0",
    backgroundColor: theme.palette.hubColors.mainFocus,
  },
}));
